import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FaUsers, FaDraftingCompass, FaBuilding, FaStar } from "react-icons/fa";

const stats = [
    { number: 120, label: "Clientes ayudados", icon: <FaUsers /> },
    { number: 300, label: "Planos vendidos", icon: <FaDraftingCompass /> },
    { number: 50, label: "Proyectos formalizados", icon: <FaBuilding /> },
    { number: 5, label: "Años de experiencia", icon: <FaStar /> }
];

const Counter = ({ value }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        let start = 0;
        const duration = 1500;
        const increment = value / (duration / 16);

        const timer = setInterval(() => {
            start += increment;

            if (start >= value) {
                start = value;
                clearInterval(timer);
            }

            setCount(Math.floor(start));
        }, 16);

        return () => clearInterval(timer);
    }, [value]);

    return <span>{count}</span>;
};

const StatsHome = () => {
    return (
        <section className="relative py-24 bg-[#1C1C1C] text-white overflow-hidden">

            {/* Blueprint Grid */}
            <div className="absolute inset-0 opacity-10">

                <svg className="w-full h-full">

                    <defs>
                        <pattern id="grid" width="60" height="60" patternUnits="userSpaceOnUse">
                            <path
                                d="M 60 0 L 0 0 0 60"
                                fill="none"
                                stroke="white"
                                strokeWidth="0.5"
                            />
                        </pattern>
                    </defs>

                    <rect width="100%" height="100%" fill="url(#grid)" />

                </svg>

            </div>

            {/* Animated Blueprint Lines */}
            <motion.svg
                className="absolute inset-0 w-full h-full opacity-20"
                viewBox="0 0 1200 400"
                fill="none"
            >

                <motion.path
                    d="M0 200 L300 200 L350 150 L600 150 L650 200 L900 200 L950 250 L1200 250"
                    stroke="#F26B1D"
                    strokeWidth="2"
                    initial={{ pathLength: 0 }}
                    whileInView={{ pathLength: 1 }}
                    transition={{ duration: 2 }}
                />

                <motion.circle
                    cx="350"
                    cy="150"
                    r="6"
                    stroke="#F26B1D"
                    strokeWidth="2"
                    fill="transparent"
                    initial={{ scale: 0 }}
                    whileInView={{ scale: 1 }}
                    transition={{ delay: 1 }}
                />

                <motion.circle
                    cx="650"
                    cy="200"
                    r="6"
                    stroke="#F26B1D"
                    strokeWidth="2"
                    fill="transparent"
                    initial={{ scale: 0 }}
                    whileInView={{ scale: 1 }}
                    transition={{ delay: 1.3 }}
                />

            </motion.svg>

            {/* Contenido */}
            <div className="relative max-w-7xl mx-auto px-6 grid md:grid-cols-4 gap-12 text-center">

                {stats.map((stat, index) => (
                    <motion.div
                        key={index}
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: index * 0.2 }}
                        viewport={{ once: true }}
                    >

                        <div className="text-3xl text-[#F26B1D] flex justify-center mb-4">
                            {stat.icon}
                        </div>

                        <h3 className="text-4xl md:text-5xl font-bold text-[#F26B1D]">
                            +<Counter value={stat.number} />
                        </h3>

                        <p className="mt-4 text-gray-300">
                            {stat.label}
                        </p>

                    </motion.div>
                ))}

            </div>

        </section>
    );
};

export default StatsHome;